import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import React from 'react'

const ROWS = ['first', 'second', 'third']

const ReactivationSelectionListSkeleton = () => (
  <Box aria-busy="true" data-testid="reactivation-selection-skeleton" sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
    {ROWS.map(row => (
      <Box key={row} sx={{ '& + &': { borderTop: 1, borderColor: 'divider' } }}>
        <Stack alignItems="center" direction="row" gap={1.5} px={1.5} py={1}>
          <Skeleton height="1rem" variant="rectangular" width="1rem" />
          <Skeleton sx={{ flex: 1 }} variant="text" />
          <Skeleton variant="text" width="4rem" />
        </Stack>
        <Stack direction="row" gap={1.5} pb={1.5} pl={4} pr={1.5}>
          <Skeleton height="1rem" variant="rectangular" width="1rem" />
          <Stack flex={1}>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="70%" />
          </Stack>
        </Stack>
      </Box>
    ))}
  </Box>
)

export default ReactivationSelectionListSkeleton
